import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import { Permission } from 'garaje/utils/ui-permissions';

// Any of these permissions are sufficient to enable Settings > Notifications in the left nav
const CAN_VISIT_NOTIFICATION_SETTINGS_AUTHZ_PERMISSIONS = [
  Permission.VISITORS_LOCATION_CONFIG_UPDATE_HOST_NOTIFICATIONS,
  Permission.VISITORS_FALLBACK_CONTACT_READ,
] as const;

export default class NotificationAbility extends Ability {
  @service declare authz: AuthzService;

  get canUpdateDevice(): boolean {
    // User can update device notification settings if they have "update devices" permission
    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_DEVICE_UPDATE);
  }

  get canUpdatePrinter(): boolean {
    // User can update printer notification settings if they have "update printers" permission
    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_PRINTER_UPDATE);
  }

  get canConfigureHost(): boolean {
    const permissions = [...CAN_VISIT_NOTIFICATION_SETTINGS_AUTHZ_PERMISSIONS];

    return this.authz.hasAnyPermissionAtCurrentLocation(permissions);
  }

  get canUpdateVisitorReminders(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_LOCATION_CONFIG_UPDATE_VISITOR_REMINDERS);
  }
}
